module.exports = __webpack_public_path__ + "img/genio.9d32afa8.png";